import { requestApi } from '@/utils/request'

export function saveDisconnectionLog(data) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/trace-disconnected',
    data: {
      logs: data,
    },
  })
}

export function saveCallErrorLog(data) {
  return requestApi({
    method: 'post',
    endpoint: '/v2/trace-call-error',
    data: {
      log: data,
    },
  })
}
